import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { MediaService } from 'src/app/shared/services/mediaservice/media.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { AddService } from 'src/app/shared/services/userservices/add.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-loan-request',
  templateUrl: './loan-request.component.html',
  styleUrls: ['./loan-request.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule,]
})
export class LoanRequestComponent implements OnInit {
  public showSpinner = false;
  selectedDuration: number | undefined;
  private _location: any;
  loanDate: any;
  user: any;
  fileName: any;
  imagePath: any;
  formData: FormData = new FormData();
  fileToUpload: any;
  loanPurpose: any;
  reason: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;


  constructor(
    private mediaService: MediaService,
    private route: ActivatedRoute,
    public router: Router,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,


    @Inject(AddService) private addService: AddService,

  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

  }

  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  loanAmountValue: number | null = null;
  calculatedInstallmentAmount: number | null = null;
  durations: number[] = [1, 2, 3, 4, 5, 6];

  selectDuration(duration: number): void {
    this.selectedDuration = duration;
    this.calculateInstallmentAmount();
  }

  calculateInstallmentAmount(): void {
    if (this.selectedDuration && this.loanAmountValue) {
      this.calculatedInstallmentAmount = parseFloat((this.loanAmountValue / this.selectedDuration).toFixed(2));
      ;
    } else {
      this.calculatedInstallmentAmount = null;
    }
  }
  selectedFileName: string | null = null;
  selectedImage: string | ArrayBuffer | null = null; // This will store the selected image data
  profileImageInvalid = false;
  onFileChange(event: any) {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileToUpload = event.target.files[0] as File;
      this.formData.append('file', fileToUpload, fileToUpload.name);
      this.uploadDocumentImage()
      const fileSizeKB = selectedFile.size / 1024;
      if (fileSizeKB <= 1025) {
        this.selectedFileName = selectedFile.name;
        this.profileImageInvalid = false;

        // Read the selected image and convert it to a data URL
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.selectedImage = e.target.result; // Set the selected image data
        };
        reader.readAsDataURL(selectedFile);
      } else {
        this.selectedFileName = null;
        this.selectedImage = null;
        this.profileImageInvalid = true;
        event.target.value = ''; // Clear the input value
      }
    }
  }


  trimText() {
    this.reason = this.reason.replace(/\s+/g, ' ').trim();
  }


  onSubmit(f: NgForm) {
    this.addService.addLoan(
      this.user.uuid,
      f.value.loanAmountValue,
      f.value.loanDate,
      this.selectedDuration,
      this.calculatedInstallmentAmount,
      f.value.loanPurpose,
      this.fileToUpload,
      f.value.loan_file
    )

      .then((value) => {

        this.showSpinner = false;

      });
    // this.router.navigate(['/payroll']);
    this.router.navigate(['/payroll'], { queryParams: { fromLoanRequest: true } });
  }

  uploadDocumentImage() {
    this.showSpinner = true;
    this.mediaService
      .uploadImage(this.formData)
      .subscribe(response => {
        this.showSpinner = false;
        let l: any;
        l = response;
        this.imagePath = l.data.path;
      },
        error => {
          this.showSpinner = false;
        }
      );
  }

  uuid(uuid: any, loanAmountValue: any, loanDate: any, selectedDuration: number | undefined, calculatedInstallmentAmount: number | null, loanPurpose: any, selectedFileName: string | null) {
    throw new Error('Method not implemented.');
  }

  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
  goBack(): void {
    this.router.navigate(['/payroll']);
  }

}
